import { IntegrationIconProps } from './types';

const Edge = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.1836 13.4359H20.098C20.098 9.91606 18.5621 7.5163 14.3743 7.5163C9.42537 7.51628 4.3926 10.738 2 14.7552C2.74111 7.7826 7.74053 2.15326 15.2673 2.15326C21.7186 2.15326 27.8309 7.08579 27.8309 15.2852V18.4026H10.2364C10.2364 22.6455 13.9377 24.3266 17.8142 24.3266C22.5317 24.3266 25.4532 22.2067 25.4532 22.2067V28.15C25.4532 28.15 22.1552 30.1533 16.8985 30.1533C10.0672 30.1533 5.24517 25.2575 5.24517 19.1696C5.24517 14.3911 8.13564 10.5759 12.1393 9.00159C10.1904 11.1419 10.1835 13.4359 10.1835 13.4359H10.1836Z"
      fill="#137AD4"
    />
  </svg>
);
export default Edge;
